'use client'

import { cn } from '@mntn-dev/ui-utilities'
import { Button } from '../buttons/button.tsx'
import { useModalContext } from './use-modal.ts'

export const ModalClose = ({ className }: { className?: string }) => {
  const context = useModalContext()

  if (!context) {
    throw new Error('ModalClose must be used within a ModalProvider')
  }

  const { onClose, ...rest } = context.getCloseProps()

  return (
    <Button
      iconLeft="XMarkIcon"
      variant="text"
      size="md"
      className={cn('absolute top-8 right-8 -mr-4 -mt-4 z-30', className)}
      onClick={onClose}
      {...rest}
    />
  )
}
